import { postApiCall, getApiCall, makeApiCallWithAny } from "./tokenService";
import { WorkShiftTimeSlotItems } from "../models/workShitTimeSlot/workShitTimeSlotItems";
import { ApiSuccess } from "./baseService";
import { WorkTimeType } from "../models/workShitTimeSlot/workTimeType";
import { WorkShiftTimeSlotItem } from "../models/workShitTimeSlot/workShiftTimeSlotItem";
import { WorkTimeSaveData } from "../models/workShitTimeSlot/workTimeSaveData";
import { IObjectEventLogItem } from "../models/eventLog/objectEventLogItem";
import { NonOverlappingWorkShiftTimeSlotSaveData } from "../components/workTimeBeta/workTimeAddBreakDialog";
import { OverlappingSlotsQueryData } from "../models/workShitTimeSlot/overlappingSlotsQueryData";
import { ISalaryRowType } from "../models/workShitTimeSlot/salaryRowType";

export const removeWorkTime = (
    workShiftTimeSlotId: string,
    allowShiftOverwrite = false
): Promise<boolean> => {
    return makeApiCallWithAny<boolean>(
        `api/workshifttimeslot/delete/${encodeURIComponent(
            workShiftTimeSlotId
        )}?allowShiftOverwrite=${allowShiftOverwrite.toString()}`,
        "DELETE",
        null,
        null
    );
};

export function removeWorkTimesBulk(ids: string[]) {
    return postApiCall<ApiSuccess>("api/workshifttimeslots/deletebulk", ApiSuccess, JSON.stringify({ ids }));
}

export const getWorkShiftTimeSlotItems = (startDate: string, endDate: string, employeeIds: string | string[], signal?: AbortSignal): Promise<WorkShiftTimeSlotItems> => {
    return getApiCall<WorkShiftTimeSlotItems>(
        `api/workshifttimeslots?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}${[employeeIds].flat().map(id => `&employeeIds=${encodeURIComponent(id)}`).join("")}`,
        WorkShiftTimeSlotItems,
        signal,
    );
};

export const getOverlappingWorkShiftTimeSlots = (
    params: OverlappingSlotsQueryData,
    signal?: AbortSignal
): Promise<WorkShiftTimeSlotItem[]> => {
    const query = new URLSearchParams(params as any).toString();

    return getApiCall<WorkShiftTimeSlotItem[]>(
        `api/workshifttimeslots/overlaps?${query}`,
        null,
        signal
    );
};

export const saveWorkShiftTimeSlot = (
    data: WorkTimeSaveData,
    allowOverwrite: boolean = false,
    validateOverlapping = true,
    allowShiftOverwrite = false
): Promise<WorkShiftTimeSlotItem> => {
    const queryString = new URLSearchParams({
        allowOverwrite: allowOverwrite.toString(),
        validateOverlapping: validateOverlapping.toString(),
        allowShiftOverwrite: allowShiftOverwrite.toString(),
    }).toString();
    return postApiCall<WorkShiftTimeSlotItem>(
        `api/workshifttimeslot/save?${queryString}`,
        WorkShiftTimeSlotItem,
        JSON.stringify(data)
    );
};

export const overwritingBreakSave = (
    data: NonOverlappingWorkShiftTimeSlotSaveData
): Promise<WorkShiftTimeSlotItem> => {
    return postApiCall<WorkShiftTimeSlotItem>(
        "api/workshifttimeslot/nonoverlappingsave",
        WorkShiftTimeSlotItem,
        JSON.stringify(data),
    );
};


export function saveWorkShiftTimeSlotsBulk(saveDataItems: WorkTimeSaveData[], allowShiftOverwrite = false) {
    return postApiCall<ApiSuccess>("api/workshifttimeslots/savebulk", ApiSuccess, JSON.stringify({ workShiftTimeSlots: saveDataItems, allowShiftOverwrite }));
}

export const lockWorkTimes = (ids: string[]): Promise<ApiSuccess> => {
    return postApiCall<ApiSuccess>("api/worktime/lock", ApiSuccess, JSON.stringify({
        ids: ids
    }));
};

export const unlockWorkTimes = (ids: string[]): Promise<ApiSuccess> => {
    return postApiCall<ApiSuccess>("api/worktime/unlock", ApiSuccess, JSON.stringify({
        ids: ids
    }));
};

export const getWorkTimeTypes = (signal?: AbortSignal): Promise<WorkTimeType[]> => {
    return getApiCall<WorkTimeType[]>("api/workshifttimeslot/worktimetypes", null, signal);
};

export const getSalaryRowTypes = (): Promise<ISalaryRowType[]> => {
    return getApiCall<ISalaryRowType[]>(
        "api/workshifttimeslot/salaryrowtypes",
        null
    );
};

export const getWorkShiftTimeSlotEventLog = (
    id: string,
    signal?: AbortSignal
): Promise<IObjectEventLogItem[]> => {
    return getApiCall<IObjectEventLogItem[]>(
        `api/workshifttimeslot/${encodeURIComponent(id)}/eventlog`,
        null,
        signal
    );
};

export const deleteCategoryFromWorkShiftTimeSlot = (
    id: string,
    category: string,
    restore: boolean
): Promise<void> => {
    return postApiCall<void>(
        `api/workshifttimeslot/${encodeURIComponent(
            id
        )}/ignorecategory/${category}?restore=${encodeURIComponent(
            restore.toString()
        )}`,
        null
    );
};
